export default __webpack_public_path__ + "static/media/dna.89afbaa6.webp";